/* ZKNO · tema de producto
   Mejora progresiva: sin JS, el formulario nativo de Shopify sigue funcionando. */

/* ---------- Barra superior: rota los mensajes en móvil ---------- */
(() => {
  const list = document.querySelector('[data-topbar]');
  if (!list) return;
  const items = [...list.children];
  if (items.length < 2) return;
  list.setAttribute('data-ready', '');
  let i = 0;
  items[0].classList.add('is-active');
  const mq = matchMedia('(max-width: 989px)');
  setInterval(() => {
    if (!mq.matches || document.hidden) return;
    items[i].classList.remove('is-active');
    i = (i + 1) % items.length;
    items[i].classList.add('is-active');
  }, 3500);
})();

/* ---------- Producto ---------- */
(() => {
  const root = document.querySelector('[data-zk-product]');
  if (!root) return;

  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => [...c.querySelectorAll(s)];
  const config = JSON.parse($('[data-zk-config]').textContent);
  const product = config.product;
  const form = $('[data-product-form]');
  const T = config.texts || {};

  /* Formato de moneda con el formato real de la tienda */
  function formatMoney(cents) {
    const fmt = config.moneyFormat || '{{amount}}';
    const pattern = /\{\{\s*(\w+)\s*\}\}/;
    const group = (n, dec, th, ds) => {
      const [i, d] = (n / 100).toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : '');
    };
    const key = (fmt.match(pattern) || [])[1];
    const map = {
      amount: () => group(cents, 2, ',', '.'),
      amount_no_decimals: () => group(cents, 0, ',', '.'),
      amount_with_comma_separator: () => group(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => group(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => group(cents, 2, "'", '.'),
      amount_with_space_separator: () => group(cents, 2, ' ', ','),
    };
    return fmt.replace(pattern, (map[key] || map.amount)());
  }

  /* ---------- Variantes ---------- */
  const optionSets = $$('[data-option]');
  const idInput = $('[data-variant-id]');
  const selectedOptions = () => optionSets.map(set => (set.querySelector('input:checked') || {}).value);
  const findVariant = opts => product.variants.find(v => v.options.every((o, i) => o === opts[i]));

  function markAvailability(opts) {
    optionSets.forEach((set, i) => {
      $$('.zk-vcard', set).forEach(card => {
        const test = opts.slice(); test[i] = card.querySelector('input').value;
        const v = findVariant(test);
        card.classList.toggle('is-unavailable', !v || !v.available);
      });
    });
  }

  function comparePrice(v) {
    if (v.compare_at_price && v.compare_at_price > v.price) return v.compare_at_price;   // dato real de Shopify
    if (config.fallbackCompare && config.fallbackCompare > v.price) return config.fallbackCompare; // referencia del editor
    return 0;
  }

  function updatePrice(v) {
    $$('[data-price]').forEach(el => { el.textContent = formatMoney(v.price); });
    const compare = comparePrice(v);
    const onSale = compare > 0;
    $$('[data-compare]').forEach(el => { el.hidden = !onSale; if (onSale) el.textContent = formatMoney(compare); });
    const offer = $('[data-offer]');
    if (offer) offer.hidden = !onSale;
    const save = $('[data-save]');
    if (save && onSale) {
      const saving = compare - v.price;
      save.textContent = (T.save || 'Ahorra [importe] ([porcentaje]% dto.)').replace('[importe]', formatMoney(saving)).replace('[porcentaje]', Math.floor((saving * 100) / compare));
    }
  }

  function updateStock(available, text) {
    const dot = $('.zk-stock__dot'), label = $('[data-stock-text]'), note = $('[data-stock-note]');
    if (dot) dot.classList.toggle('zk-stock__dot--off', !available);
    if (label) label.textContent = text;
    if (note) note.hidden = !available;
  }

  function setButtons(enabled, label) {
    $$('[data-buy-now]').forEach(b => { b.disabled = !enabled; const s = b.querySelector('[data-buy-label]'); if (s) s.textContent = label; });
    const add = $('[data-add]');
    if (add) add.disabled = !enabled;
  }

  function updateVariant() {
    const opts = selectedOptions();
    const variant = findVariant(opts);
    optionSets.forEach((set, i) => { const l = $('[data-option-label]', set); if (l) l.textContent = opts[i]; });
    markAvailability(opts);

    if (!variant) {
      setButtons(false, T.unavailable || 'No disponible');
      updateStock(false, T.unavailable || 'Combinación no disponible');
      return;
    }
    idInput.value = variant.id;
    updatePrice(variant);
    updateStock(variant.available, variant.available ? (T.available || 'Disponible') : (T.soldout || 'Agotado'));
    setButtons(variant.available, variant.available ? config.buyLabel : (T.soldout || 'Agotado'));
    if (variant.featured_media) goToMedia(variant.featured_media.id);

    const url = new URL(location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState(null, '', url);
  }
  optionSets.forEach(set => set.addEventListener('change', updateVariant));
  if (optionSets.length) markAvailability(selectedOptions());

  /* ---------- Galería ---------- */
  const track = $('[data-track]');
  const slides = $$('.zk-gallery__slide');
  const dots = $$('[data-dot]');
  const thumbs = $$('[data-thumb]');
  const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));

  function setActive(i) {
    dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
    thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
  }
  function goTo(i, smooth = true) {
    const s = slides[i]; if (!s) return;
    track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    setActive(i);
  }
  function goToMedia(id) {
    const i = slides.findIndex(s => s.dataset.mediaId == id);
    if (i > -1) goTo(i);
  }
  thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
  const prev = $('[data-prev]'), next = $('[data-next]');
  if (prev) prev.addEventListener('click', () => goTo((current() - 1 + slides.length) % slides.length));
  if (next) next.addEventListener('click', () => goTo((current() + 1) % slides.length));
  let raf;
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => setActive(current()));
  }, { passive: true });
  track.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, current() + 1)); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, current() - 1)); }
  });
  const initial = product.variants.find(v => v.id == idInput.value);
  const startIndex = initial && initial.featured_media ? slides.findIndex(s => s.dataset.mediaId == initial.featured_media.id) : 0;
  if (startIndex > 0) requestAnimationFrame(() => goTo(startIndex, false)); else setActive(0);

  /* ---------- Lightbox ---------- */
  const lb = $('[data-lightbox]'), lbImg = $('[data-lightbox-img]');
  if (lb && lb.showModal) {
    $$('[data-zoom]').forEach(b => b.addEventListener('click', () => {
      lbImg.src = b.dataset.zoom;
      lbImg.alt = (b.querySelector('img') || {}).alt || '';
      lb.showModal();
    }));
    $('[data-lightbox-close]').addEventListener('click', () => lb.close());
    lb.addEventListener('click', e => { if (e.target === lb || e.target === lbImg) lb.close(); });
  }

  /* ---------- Cantidad ---------- */
  const qty = $('[data-qty-input]');
  $$('[data-qty]').forEach(b => b.addEventListener('click', () => {
    qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10));
  }));

  /* ---------- Añadir al carrito (AJAX con respaldo nativo) ----------
     "Comprar ahora" NO se intercepta: envía el formulario nativo a /cart/add
     con return_to=/checkout (variante + cantidad seleccionadas). */
  const addBtn = $('[data-add]');
  const cartCount = document.querySelector('[data-cart-count]');
  const rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  form.addEventListener('submit', async e => {
    if (!addBtn || e.submitter !== addBtn) return;
    e.preventDefault();
    addBtn.classList.add('is-loading');
    try {
      const res = await fetch(rootUrl + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      if (window.ZKCart) await window.ZKCart.open();
      else {
        const cart = await (await fetch(rootUrl + 'cart.js')).json();
        if (cartCount) cartCount.textContent = cart.item_count;
        toast('Añadido al carrito', true);
      }
    } catch (err) {
      toast(err.message || 'No se ha podido añadir', false);
    } finally {
      addBtn.classList.remove('is-loading');
    }
  });

  function toast(msg, ok) {
    let t = document.querySelector('.zk-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'zk-toast';
      t.setAttribute('role', 'status');
      document.body.append(t);
    }
    t.innerHTML = `<span>${msg}</span>${ok ? `<a href="${rootUrl}cart">Ver carrito</a>` : ''}`;
    t.classList.toggle('is-error', !ok);
    t.classList.add('is-visible');
    clearTimeout(t._h);
    t._h = setTimeout(() => t.classList.remove('is-visible'), 4000);
  }

  /* ---------- Barra fija móvil ---------- */
  const sticky = $('[data-sticky]');
  const mainBuy = $('.zk-buy');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.querySelector('button').tabIndex = show ? 0 : -1;
    }).observe(mainBuy);
  }
})();

/* ---------- Carrusel de reseñas (swipe + flechas + puntos) ---------- */
(() => {
  document.querySelectorAll('[data-carousel]').forEach(root => {
    const track = root.querySelector('[data-carousel-track]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    const dotsWrap = root.querySelector('[data-carousel-dots]');
    if (!track) return;
    const items = [...track.children];
    let dots = [];

    const step = () => {
      const first = items[0];
      if (!first || !first.offsetWidth) return Math.max(1, track.clientWidth);
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      const per = Math.max(1, Math.floor((track.clientWidth + gap) / (first.offsetWidth + gap)));
      return per * (first.offsetWidth + gap);
    };
    const pages = () => Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth) / step() - 0.05) + 1);
    const page = () => Math.min(pages() - 1, Math.round(track.scrollLeft / step()));

    function buildDots() {
      if (!dotsWrap) return;
      const n = pages();
      dotsWrap.innerHTML = '';
      dots = Array.from({ length: n }, (_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.tabIndex = -1;
        b.addEventListener('click', () => track.scrollTo({ left: i * step(), behavior: 'smooth' }));
        dotsWrap.append(b);
        return b;
      });
      dotsWrap.hidden = n < 2;
      sync();
    }
    function sync() {
      const p = page();
      dots.forEach((d, i) => d.classList.toggle('is-active', i === p));
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: 'smooth' }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: 'smooth' }); }
    });
    let rt;
    addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(buildDots, 150); });
    buildDots();
    addEventListener('load', buildDots);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildDots);
  });
})();


/* ---------- Carrito lateral (carrito real de Shopify) ---------- */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const panel = drawer.querySelector('.zk-drawer__panel');
  const list = drawer.querySelector('[data-cart-drawer-items]');
  const foot = drawer.querySelector('[data-cart-drawer-foot]');
  const subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
  const countEl = drawer.querySelector('[data-cart-drawer-count]');
  const headerCount = document.querySelector('[data-cart-count]');
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cfgEl = document.querySelector('[data-zk-config]');
  const moneyFormat = (cfgEl && JSON.parse(cfgEl.textContent).moneyFormat) || '{{amount_with_comma_separator}} €';
  let lastFocus = null;
  const TXT = { empty: drawer.dataset.textEmpty || 'Tu carrito está vacío.', cont: drawer.dataset.textContinue || 'Seguir comprando', remove: drawer.dataset.textRemove || 'Eliminar' };

  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  function money(cents) {
    const m = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/); const key = m ? m[1] : 'amount';
    const fmt = (n, d, t, dec) => { const [i, f] = (n / 100).toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? dec + f : ''); };
    const v = { amount: fmt(cents, 2, ',', '.'), amount_no_decimals: fmt(cents, 0, ',', '.'),
      amount_with_comma_separator: fmt(cents, 2, '.', ','), amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_space_separator: fmt(cents, 2, ' ', ','), amount_with_apostrophe_separator: fmt(cents, 2, "'", '.') }[key] || fmt(cents, 2, '.', ',');
    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  const img = (url, w) => url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '';

  function render(cart) {
    if (headerCount) headerCount.textContent = cart.item_count;
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.items.length) {
      list.innerHTML = '<div class="zk-drawer__empty"><p>' + esc(TXT.empty) + '</p><button type="button" class="zk-btn zk-btn--outline" data-cart-close>' + esc(TXT.cont) + '</button></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    subtotalEl.textContent = money(cart.total_price);
    list.innerHTML = '<ul class="zk-drawer__list">' + cart.items.map((it, i) => {
      const variant = it.variant_title && !it.product_has_only_default_variant ? '<p class="zk-line__variant">' + esc(it.options_with_values.map(o => o.name + ': ' + o.value).join(' · ')) + '</p>' : '';
      const was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '<li class="zk-line" data-line="' + (i + 1) + '">' +
        '<a class="zk-line__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '" width="96" height="96" decoding="async">' : '') + '</a>' +
        '<div class="zk-line__info">' +
          '<a class="zk-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="zk-line__row">' +
            '<div class="zk-line__qty" role="group" aria-label="Cantidad">' +
              '<button type="button" data-qty-change="-1" aria-label="Quitar una unidad">−</button>' +
              '<span aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" data-qty-change="1" aria-label="Añadir una unidad">+</button>' +
            '</div>' +
            '<p class="zk-line__price">' + was + '<span>' + money(it.final_line_price) + '</span></p>' +
          '</div>' +
          '<button type="button" class="zk-line__remove" data-remove>' + esc(TXT.remove) + '</button>' +
        '</div></li>';
    }).join('') + '</ul>';
  }

  async function refresh() {
    const cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
    render(cart);
    return cart;
  }
  async function change(line, quantity) {
    drawer.classList.add('is-busy');
    try {
      const res = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || cart.message || 'Error');
      render(cart);
    } catch (e) { await refresh(); }
    finally { drawer.classList.remove('is-busy'); }
  }

  function show() {
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('zk-lock');
    requestAnimationFrame(() => { drawer.classList.add('is-open'); panel.focus({ preventScroll: true }); });
  }
  function close() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('zk-lock');
    setTimeout(() => { drawer.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  drawer.addEventListener('click', e => {
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    const line = e.target.closest('[data-line]');
    if (!line) return;
    const n = +line.dataset.line;
    const qty = +line.querySelector('.zk-line__qty span').textContent;
    const step = e.target.closest('[data-qty-change]');
    if (step) change(n, Math.max(0, qty + +step.dataset.qtyChange));
    if (e.target.closest('[data-remove]')) change(n, 0);
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) close(); });

  window.ZKCart = { open: async () => { await refresh(); show(); }, close, refresh };
})();

/* ---------- Contadores animados (se activan al entrar en pantalla) ---------- */
(() => {
  const sections = document.querySelectorAll('[data-zk-stats]');
  if (!sections.length) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = n => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const ease = t => 1 - Math.pow(1 - t, 3);
  sections.forEach(sec => {
    const els = [...sec.querySelectorAll('[data-count-to]')];
    if (reduce || !('IntersectionObserver' in window)) return; // se quedan los números finales
    const dur = parseInt(sec.dataset.duration, 10) || 1200;
    els.forEach(el => {
      const to = parseFloat(el.dataset.countTo) || 0;
      if (to === 0) el.closest('.zk-stat__num').classList.add('is-fading');
      else el.textContent = '0';
    });
    const run = () => {
      els.forEach(el => {
        const to = parseFloat(el.dataset.countTo) || 0;
        const wrap = el.closest('.zk-stat__num');
        if (to === 0) { wrap.classList.add('is-in'); return; }
        const t0 = performance.now();
        const tick = now => {
          const p = Math.min(1, (now - t0) / dur);
          el.textContent = fmt(Math.round(to * ease(p)));
          if (p < 1) requestAnimationFrame(tick); else el.textContent = fmt(to);
        };
        requestAnimationFrame(tick);
      });
    };
    const io = new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting)) { io.disconnect(); run(); }
    }, { threshold: 0.3 });
    io.observe(sec.querySelector('.zk-stats__grid') || sec);
  });
})();
